import {
  SET_BANKS,
  SET_CASHIERS,
  SET_FINANCIAL,
  SET_FINANCIALS,
  SET_FUNDS,
} from "../../constants/financialConstants";

const initialState = {
  financial: null,
  financials: [],
  banks: [],
  funds: [],
  cashiers: [],
  filteredFinancials: [],
};

const financialReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_FINANCIAL:
      return {
        ...state,
        financial: action.financial,
      };
    case SET_FINANCIALS:
      return {
        ...state,
        financials: action.filtered ? state.financials : action.financials,
        filteredFinancials: action.filtered ? action.financials : state.filteredFinancials,
      };
    case SET_BANKS:
      return {
        ...state,
        banks: action.filtered ? state.banks : action.banks,
        filteredBanks: action.filtered ? action.banks : state.filteredBanks,
      };
    case SET_FUNDS:
      return {
        ...state,
        funds: action.filtered ? state.funds : action.funds,
        filteredFunds: action.filtered ? action.funds : state.filteredFunds,
      };
    case SET_CASHIERS:
      return {
        ...state,
        cashiers: action.filtered ? state.cashiers : action.cashiers,
        filteredCashiers: action.filtered ? action.cashiers : state.filteredCashiers,
      };
    default:
      return state;
  }
};

export default financialReducer;
